import React from 'react';
import { Clock } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-[#4C1D95] text-white py-12 px-4 sm:py-16 sm:px-6 md:py-28" data-id="element-130">
      <div className="max-w-5xl mx-auto" data-id="element-131">
        {/* The Rule */}
        <div className="max-w-3xl mx-auto text-center mb-12 sm:mb-16 md:mb-20" data-id="element-132">
          <div className="inline-flex items-center justify-center p-2.5 sm:p-3 bg-[#7C3AED]/30 rounded-full mb-4 sm:mb-6" data-id="element-133">
            <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-[#A3E635]" data-id="element-134" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold mb-4 sm:mb-6" data-id="element-135">
            Lo que cambia todo: <br data-id="element-136" />
            <span className="text-[#A3E635]" data-id="element-137">La Regla 24–48h</span>
          </h2>
          <p className="text-base sm:text-xl md:text-2xl text-purple-200 mb-8 sm:mb-10 leading-relaxed" data-id="element-138">
            Tu cuerpo te da una respuesta clara si sabes dónde mirar:{' '}
            <br className="hidden sm:block" data-id="element-139" />
            <span className="italic text-white" data-id="element-140">
              Lo que haces hoy se paga — o se cobra — mañana y pasado.
            </span>
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 text-left" data-id="element-141">
            <div className="bg-[#5B21B6] p-4 sm:p-6 rounded-lg border border-[#7C3AED]" data-id="element-142">
              <div className="flex items-center mb-2 sm:mb-3" data-id="element-143">
                <div className="w-3 h-3 rounded-full bg-[#84CC16] mr-3" data-id="element-144"></div>
                <h3 className="font-bold text-base sm:text-lg" data-id="element-145">Luz Verde</h3>
              </div>
              <p className="text-sm sm:text-base text-purple-200" data-id="element-146">
                Si 24–48 horas después estás igual o mejor:{' '}
                <span className="text-white font-medium" data-id="element-147">vas bien.</span>
              </p>
            </div>
            <div className="bg-[#5B21B6] p-4 sm:p-6 rounded-lg border border-[#7C3AED]" data-id="element-148">
              <div className="flex items-center mb-2 sm:mb-3" data-id="element-149">
                <div className="w-3 h-3 rounded-full bg-[#EF4444] mr-3" data-id="element-150"></div>
                <h3 className="font-bold text-base sm:text-lg" data-id="element-151">Luz Roja</h3>
              </div>
              <p className="text-sm sm:text-base text-purple-200" data-id="element-152">
                Si 24–48 horas después estás peor y dura:{' '}
                <span className="text-white font-medium" data-id="element-153">
                  te pasaste la dosis.
                </span>
              </p>
            </div>
          </div>

          <p className="mt-6 sm:mt-8 text-base sm:text-lg font-medium text-[#A3E635]" data-id="element-154">
            No necesitas adivinar. Necesitas medir.
          </p>
        </div>

        {/* The Matrix */}
        <div className="relative bg-[#F5F0E6] text-[#333333] rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-16 overflow-hidden" data-id="element-155">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#7C3AED]/10 rounded-full -mr-32 -mt-32 blur-3xl" data-id="element-156"></div>

          <div className="relative z-10" data-id="element-157">
            <div className="text-center mb-8 sm:mb-12" data-id="element-158">
              <span className="text-[#7C3AED] font-bold tracking-widest uppercase text-xs sm:text-sm" data-id="element-159">
                El Método
              </span>
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold mt-2 mb-3 sm:mb-4 text-[#4C1D95]" data-id="element-160">
                La Matriz 4C
              </h3>
              <p className="text-sm sm:text-base md:text-lg text-[#555555] max-w-2xl mx-auto" data-id="element-161">
                La mayoría falla porque intenta "hacer de todo". Pero tu cuerpo
                no está en "todo". Está en una fase.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-162">
              {[{
              title: 'Calmar',
              desc: 'Bajar la amenaza',
              icon: '01'
            }, {
              title: 'Conectar',
              desc: 'Recuperar control',
              icon: '02'
            }, {
              title: 'Coordinar',
              desc: 'Integrar movimiento',
              icon: '03'
            }, {
              title: 'Consolidar',
              desc: 'Volver a la carga',
              icon: '04'
            }].map((phase, i) => <div key={i} className="bg-white p-4 sm:p-6 rounded-xl shadow-sm border border-[#E8E3D9] flex flex-col items-center text-center" data-id="element-163">
                  <span className="text-2xl sm:text-4xl font-bold text-[#7C3AED]/20 mb-2 sm:mb-4" data-id="element-164">
                    {phase.icon}
                  </span>
                  <h4 className="text-base sm:text-xl font-bold text-[#4C1D95] mb-1 sm:mb-2" data-id="element-165">
                    {phase.title}
                  </h4>
                  <p className="text-xs sm:text-sm text-[#666666]" data-id="element-166">
                    {phase.desc}
                  </p>
                </div>)}
            </div>

            <div className="mt-8 sm:mt-12 text-center" data-id="element-167">
              <p className="text-sm sm:text-base text-[#555555] italic" data-id="element-168">
                Cada fase tiene un objetivo, errores comunes, ejercicios que
                suman y señales que te dicen "sube" o "baja".
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}